<div class="auth-container" [@fadeIn]>
  <div class="auth-background">
    <div class="gradient-orb gradient-orb-1"></div>
    <div class="gradient-orb gradient-orb-2"></div>
    <div class="gradient-orb gradient-orb-3"></div>
  </div>

  <div class="auth-content">
    <div class="auth-card">
      <!-- Top bar: Brand + Theme-Toggle -->
      <div class="desk-top">
        <div class="fp-brand">
          <img
            src="../../../../../assets/img/logo-text.svg"
            alt="FixPlaner"
            class="logo"
          />
        </div>
        <div class="auth-top-actions">
          <xds-icon-button
            [icon]="'fa-light ' + getThemeIconClass()"
            [ariaLabel]="'REG_THEME_TOGGLE_LABEL' | translate"
            (clicked)="toggleTheme()"
          ></xds-icon-button>
        </div>
      </div>

      <!-- Greeting (nur bei Loading + Success — Error hat eigenen Title) -->
      <div class="desk-greet" *ngIf="!errorMessage">
        <h1>
          {{ "ACCEPT_CO_GREET_LINE_1" | translate }}
          <span class="grad">{{ "ACCEPT_CO_GREET_BRAND" | translate }}</span>
        </h1>
        <p class="lede">{{ "ACCEPT_CO_GREET_LEDE" | translate }}</p>
      </div>

      <!-- Loading State -->
      <div *ngIf="isLoading" class="loading-container">
        <xds-spinner size="lg"></xds-spinner>
        <p>{{ 'LOADING' | translate }}...</p>
      </div>

      <!-- Error State -->
      <div *ngIf="!isLoading && errorMessage" class="error-container">
        <div class="error-icon">
          <i class="fa-light fa-circle-xmark"></i>
        </div>
        <h2>{{ 'ERROR' | translate }}</h2>
        <!-- role="alert" kommt vom Kit (variant="danger"); Fokus setzt die Komponente -->
        <xds-banner #errorBanner variant="danger" tabindex="-1" class="error-message-text">{{ errorMessage }}</xds-banner>

        <div class="action-buttons">
          <xds-button
            variant="secondary"
            [block]="true"
            iconLeft="fa-light fa-arrow-left"
            (clicked)="goToLogin()"
          >
            {{ 'GO_TO_LOGIN' | translate }}
          </xds-button>
        </div>
      </div>

      <!-- Success State -->
      <div *ngIf="!isLoading && successMessage" class="success-container">
        <div class="success-icon">
          <i class="fa-light fa-circle-check"></i>
        </div>
        <h2>{{ 'SUCCESS' | translate }}!</h2>
        <p class="success-message-text">{{ successMessage }}</p>
        <p class="redirect-info">{{ 'REDIRECTING_TO_LOGIN' | translate }}...</p>
      </div>

      <!-- Invitation Info -->
      <div *ngIf="!isLoading && !errorMessage && !successMessage && invitationInfo?.IsValid">
        <h1 class="title">{{ 'COMPANY_INVITATION_TITLE' | translate }}</h1>

        <div class="invitation-info">
          <xds-badge class="company-name-badge" variant="info" [solid]="true" icon="fa-light fa-building">
            {{ invitationInfo.CompanyName }}
          </xds-badge>

          <p class="invitation-text">
            {{ 'COMPANY_INVITATION_TEXT' | translate: { companyName: invitationInfo.CompanyName } }}
          </p>

          <div class="role-info">
            <span class="role-label">{{ 'YOUR_ROLE' | translate }}:</span>
            <span class="role-value" [class.teamleader]="invitationInfo.IsTeamLeader">
              <i [class]="invitationInfo.IsTeamLeader ? 'fa-light fa-user-crown' : 'fa-light fa-user'"></i>
              {{ getRoleText() }}
            </span>
          </div>

          <div class="email-info">
            <span class="email-label">{{ 'EMAIL' | translate }}:</span>
            <span class="email-value">{{ invitationInfo.Email }}</span>
          </div>
        </div>

        <!-- Login Required Notice -->
        <div *ngIf="!isLoggedIn" class="login-notice">
          <i class="fa-light fa-info-circle"></i>
          <p>{{ 'LOGIN_REQUIRED_TO_ACCEPT' | translate }}</p>
        </div>

        <!-- Already Logged In Notice -->
        <div *ngIf="isLoggedIn" class="logged-in-notice">
          <i class="fa-light fa-check-circle"></i>
          <p>{{ 'LOGGED_IN_AS' | translate: { email: currentUserEmail } }}</p>
        </div>

        <!-- Action Buttons -->
        <div class="action-buttons">
          <xds-button
            *ngIf="!isLoggedIn"
            variant="primary"
            [block]="true"
            iconLeft="fa-light fa-sign-in-alt"
            (clicked)="goToLogin()"
          >
            {{ 'LOGIN_TO_ACCEPT' | translate }}
          </xds-button>

          <xds-button
            *ngIf="isLoggedIn"
            variant="primary"
            [block]="true"
            iconLeft="fa-light fa-check"
            [loading]="isAccepting"
            (clicked)="acceptInvitation()"
          >
            {{ isAccepting ? ('ACCEPTING' | translate) + '...' : ('ACCEPT_INVITATION' | translate) }}
          </xds-button>
        </div>

        <!-- Info Box -->
        <div class="info-box">
          <i class="fa-light fa-lightbulb"></i>
          <p>{{ 'COMPANY_INVITATION_INFO' | translate }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
